module.exports = __webpack_public_path__ + "static/media/page.cb3ca641.svg";